<template>
	<div>
		<!-- 管理图标 -->
		<div class="sideBar_icon">
			<!--<img src="../../assets/img/main/logo.png">-->
			<p>{{userCompany}}</p>
		</div>
		<el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="#1c2e43"
			text-color="#fff" active-text-color="#96fbc4" router :default-active="onRoutes">
			<template v-for="(item, index) in navMenu">
				<el-menu-item v-if="!item.childs" :index="item.path" :key="index">
					<!-- <i class="el-icon-setting"></i> -->
					<img :src="item.img" style="width: 18px;height: 18px;margin-right: 5px;">
					<span slot="title">{{item.title}}</span>
				</el-menu-item>

				<el-submenu v-if="item.childs" :index="item.path" :key="index">
					<template slot="title">
						<i class="el-icon-location"></i>
						<span>{{item.title}}</span>
					</template>
					<el-menu-item v-for="(value,i) in item.childs" :key="i" :index="value.path">
						{{value.title}}
					</el-menu-item>
				</el-submenu>

			</template>

		</el-menu>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				userCompany:'',
				path: "",
				navMenu: [
				// {
				// 	title: "基本信息",
				// 	img:require('../../assets/img/main/基本信息.png'),
				// 	path: "/mrecord"
				// },
				],
				navList1:[
					/*{
						title: "项目管理",
						img: require('../../assets/img/main/项目管理.png'),
						path: "/basicinfo"
					},*/
          {
						title: "项目申报",
						img:require('../../assets/img/main/项目申报.png'),
						path: "/infochange",
					}/*,{
						title: "申报管理",
						img:require('../../assets/img/main/申报管理.png'),
						path: "/contribute"
					},*/
				],
				navList2:[
					{
						title: "项目申报",
						img:require('../../assets/img/main/项目申报.png'),
						path: "/infochange",
					},
				]
			}
		},
		created() {
			this.level()
		},
		watch: {
			
		},
		computed:{
			onRoutes(){
				const route = this.$route
				const {meta,path} = route
				if(meta.activeMenu){
					return meta.activeMenu
				}
				return path
			},
		},
		methods: {
			level(){
				const level = localStorage.getItem('userLevel')
				this.userCompany = localStorage.getItem('userCompany')
				if(level === '1'){
					this.navMenu = this.navList1
					return
				}
				this.navMenu = this.navList2
			},
			handleClose() {

			},
			handleOpen() {

			},
		}
	}
</script>

<style>
	.sideBar_icon {
		width: 200px;
		height: 100px;
		line-height: 100px;
		color: #ffffff;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.sideBar_icon img {
		width: 30px;
		height: 30px;
		padding-left: 10px;
	}

	.sideBar_icon p {
		padding-left: 15px;
		padding-right: 15px;
		line-height: 30px;
	}
</style>
